<div class="header">
    <h2>{{ 'packages.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="packages-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'packages.error.unavailable' | translate" />
} @else if (package(); as pkg) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'packages.fieldset.basic' | translate }}</h2>
            <app-form-input [control]="form.controls.name" [label]="'packages.form.name' | translate" inputId="name" testId="packages-edit-name" />

            <app-form-textarea
                [control]="form.controls.description"
                [label]="'packages.form.description' | translate"
                inputId="description"
                testId="packages-edit-description"
            />

            <div class="media-field">
                <span class="label">{{ 'packages.form.thumbnail' | translate }}</span>
                @if (form.controls.thumbnailMediaId.value; as thumbnailId) {
                    <div class="media-preview">
                        <app-media-image [mediaId]="thumbnailId" [alt]="'packages.form.thumbnail' | translate" />
                    </div>
                }
                <div class="media-actions">
                    <p-button
                        [label]="'packages.form.selectThumbnail' | translate"
                        icon="pi pi-image"
                        [outlined]="true"
                        severity="secondary"
                        data-test="packages-edit-select-thumbnail"
                        (onClick)="onSelectThumbnail()"
                    />
                    @if (form.controls.thumbnailMediaId.value) {
                        <p-button
                            [label]="'packages.form.removeThumbnail' | translate"
                            icon="pi pi-times"
                            [text]="true"
                            severity="secondary"
                            data-test="packages-edit-remove-thumbnail"
                            (onClick)="removeThumbnail()"
                        />
                    }
                </div>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'packages.fieldset.content' | translate }}</h2>
            <app-form-multiselect
                [control]="form.controls.courseIds"
                [label]="'packages.form.courses' | translate"
                [options]="courseOptions()"
                [filter]="true"
                inputId="courseIds"
                testId="packages-edit-course-ids"
            />

            <app-form-multiselect
                [control]="form.controls.pathwayIds"
                [label]="'packages.form.pathways' | translate"
                [options]="pathwayOptions()"
                [filter]="true"
                inputId="pathwayIds"
                testId="packages-edit-pathway-ids"
            />
        </div>

        <div class="section">
            <h2>{{ 'packages.fieldset.availability' | translate }}</h2>
            <app-form-radio-button
                [control]="form.controls.availabilityType"
                [label]="'packages.form.availability' | translate"
                [options]="availabilityOptions"
                inputId="availabilityType"
                name="availabilityType"
                testId="packages-edit-availability-type"
            />

            @if (isRestricted()) {
                <app-form-multiselect
                    [control]="form.controls.assignedSchoolIds"
                    [label]="'packages.form.schools' | translate"
                    [options]="schoolOptions()"
                    [filter]="true"
                    inputId="assignedSchoolIds"
                    testId="packages-edit-assigned-school-ids"
                />

                <app-form-multiselect
                    [control]="form.controls.assignedOrganisationIds"
                    [label]="'packages.form.organisations' | translate"
                    [options]="organisationOptions()"
                    [filter]="true"
                    inputId="assignedOrganisationIds"
                    testId="packages-edit-assigned-organisation-ids"
                />
            }
        </div>

        <div class="section">
            <h2>{{ 'packages.fieldset.pricing' | translate }}</h2>
            <app-pricing-configurator
                [pricingList]="form.controls.pricingList"
                [customPricingList]="form.controls.customPricingList"
                [pricingEntities]="pricingEntities()"
            />

            <div class="purchasable">
                <app-form-checkbox
                    [control]="form.controls.isPurchasable"
                    [label]="'packages.purchasable.label' | translate"
                    inputId="isPurchasable"
                    testId="packages-edit-is-purchasable"
                />
                @if (form.controls.isPurchasable.disabled) {
                    <p class="hint">{{ 'packages.purchasable.disabledHint' | translate }}</p>
                }
            </div>
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'packages.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="packages-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'packages.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="packages-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
